export default __webpack_public_path__ + "static/media/GuideListView.31150789.jpg";